<template>
  <UiSelect
    v-model="desktopGridValue"
    value-key="value"
    title-key="label"
    hide-details
    :items="desktopGridOptions"
    name="desktop-grid"
    dropdown-classes="w-45.5 !bg-primary !p-4 !border-primary"
  >
    <template #activator="{ selectedItem, open }">
      <button class="relative flex items-center gap-1 text-xs uppercase">
        <span class="inline-flex items-center"> {{ $t("view") }}: </span>
        <span v-if="selectedItem" class="flex-auto flex items-center">
          <UiIcon
            v-if="!Array.isArray(selectedItem) && selectedItem"
            :name="selectedItem.icon"
            class="size-6"
          />
          ({{
            Array.isArray(selectedItem)
              ? selectedItem.map((item) => item?.displayName).join(", ")
              : selectedItem.displayName
          }})
        </span>
        <UiIcon
          :name="open ? 'chevron_up' : 'chevron_down'"
          class="pointer-events-none size-3 flex-shrink-0"
        />
      </button>
    </template>
    <template #item="{ item, selected }">
      <span class="inline-flex items-center w-full text-xs text-white font-normal gap-2">
        <UiIcon
          :name="selected ? 'radio-checked' : 'radio-unchecked'"
          class="size-5"
        />
        {{ item.label }}
        <UiIcon :name="item.icon" class="size-5 ml-auto" />
      </span>
    </template>
  </UiSelect>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: number;
}>();

const emit = defineEmits(["update:modelValue"]);

const { t } = useI18n();
const value = useVModel(props, "modelValue", emit);

const desktopGridOptions = [
  {
    value: 2,
    label: t("twoColumnGrid"),
    displayName: t("twoGrid"),
    icon: "two-columns",
  },
  {
    value: 4,
    label: t("fourColumnGrid"),
    displayName: t("fourGrid"),
    icon: "four-columns",
  },
];

const desktopGridValue = computed({
  get() {
    return desktopGridOptions.find((item) => item.value === value.value);
  },
  set(val) {
    setDesktopGrid(val);
  },
});

function setDesktopGrid(
  selectedValue:
    | Nullable<(typeof desktopGridOptions)[number]>
    | undefined
    | (Nullable<(typeof desktopGridOptions)[number]> | undefined)[],
) {
  value.value = (!Array.isArray(selectedValue) && selectedValue?.value) || 4;
}
</script>
